import { FormGroupComponent } from "./form-group/form-group.component";
import { FormNumberComponent } from "./form-number/form-number.component";
import { FormSegmentComponent } from "./form-segment/form-segment.component";
import { FormSelectComponent } from "./form-select/form-select.component";
import { FormTextComponent } from "./form-text/form-text.component";
import { FormTextareaComponent } from "./form-textarea/form-textarea.component";
import { FormToggleComponent } from "./form-toggle/form-toggle.component";
import { InputTextIconComponent } from "./input-text-icon/input-text-icon.component";

export const COMPONENT_DECLARATIONS = [
	FormGroupComponent,
	FormTextComponent,
	FormNumberComponent,
	FormTextareaComponent,
	FormToggleComponent,
	FormSelectComponent,
	FormSegmentComponent,
	InputTextIconComponent,
];

export default new Map<string, any>([
	["text", FormTextComponent],
	["number", FormNumberComponent],
	["textarea", FormTextareaComponent],
	["toggle", FormToggleComponent],
	["select", FormSelectComponent],
	["segment", FormSegmentComponent],
]);
